export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_SIGNUPSIGNINPOLICYID,
        resetPassword : process.env.REACT_APP_RESETPOLICYID,
        editProfile: ""
    },
    authorities: {
        signUpSignIn: {
            authority: "https://" + process.env.REACT_APP_INSTANCE + "/" + process.env.REACT_APP_AUTHORITY + "/" + process.env.REACT_APP_SIGNUPSIGNINPOLICYID
        },
        resetPassword: {
            authority: "https://" + process.env.REACT_APP_INSTANCE + "/" + process.env.REACT_APP_AUTHORITY + "/" + process.env.REACT_APP_RESETPOLICYID
        }
    },
    authorityDomain: "https://" + process.env.REACT_APP_INSTANCE + "/" + process.env.REACT_APP_AUTHORITY
};
